class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    
    // delegat – prinde click pe overlay indiferent de re-render
    this.addEventListener('click', (e) => {
      if (e.target && e.target.id === 'CartDrawer-Overlay') this.close();
    });

    // animează și la update-uri de cantitate (după ce DOM-ul e înlocuit)
    this._progressUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      // un micro-delay ca să fim siguri că replaceWith a terminat
      setTimeout(() => this.animateProgress(), 0);
    });

    this.setHeaderCartIconAccessibility();
  }

  disconnectedCallback() {
  if (this._progressUnsub) this._progressUnsub();
}

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        // const containerToTrapFocusOn = this.classList.contains('is-empty')
        //   ? this.querySelector('.drawer__inner-empty')
        //   : document.getElementById('CartDrawer');
        // const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        // trapFocus(containerToTrapFocusOn, focusElement);
        // container sigur: empty -> fallback pe .drawer__inner dacă nu există .drawer__inner-empty
      const isEmpty = this.classList.contains('is-empty');
      const container =
        (isEmpty
          ? (this.querySelector('.drawer__inner-empty') || this.querySelector('.drawer__inner'))
          : (document.getElementById('CartDrawer') || this.querySelector('.drawer__inner')))
     || this; // ultim fallback
 
     // element de focus: butonul de închidere, apoi primul focusabil din container, altfel containerul
      let focusEl = this.querySelector('.drawer__close') || this.querySelector('.drawer__inner');
      if (!focusEl || typeof focusEl.focus !== 'function') {
        const focusables = typeof getFocusableElements === 'function' ? getFocusableElements(container) : [];
        focusEl = focusables[0] || container;
      }
      // cheamă doar dacă avem un container valid
     if (container) trapFocus(container, focusEl);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  animateProgress() {
  // respectă preferința de „reduce motion”
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const container = this.querySelector('[data-cart-progress]');
  if (!container) return;

  const bar = container.querySelector('[data-progress-bar]');
  if (!bar) return;

  const newProgress = parseFloat(container.dataset.progress || '0');
  const prev = parseFloat(this.dataset.prevProgress || '0');

  // setăm startul fără tranziție
  bar.style.transition = 'none';
  bar.style.width = prev + '%';

  // forțăm reflow, apoi animăm spre noua valoare
  // (următoarea „ramă”)
  // eslint-disable-next-line no-unused-expressions
  bar.offsetHeight;
  bar.style.transition = ''; // se aplică CSS-ul cu transition
  requestAnimationFrame(() => {
    bar.style.width = newProgress + '%';
  });

  // salvăm pentru tura următoare
  this.dataset.prevProgress = String(newProgress);
}


  renderContents(parsedState) {
    // this.querySelector('.drawer__inner').classList.contains('is-empty') &&
    // this.querySelector('.drawer__inner').classList.remove('is-empty');
    // setează corect starea pe elementul <cart-drawer> în funcție de item_count
    if (parsedState && typeof parsedState.item_count === 'number') {
      this.classList.toggle('is-empty', parsedState.item_count === 0);
    } else {
      // fallback: dacă nu avem parsedState.item_count, asumăm că nu e empty după add
      this.classList.remove('is-empty');
    }

    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
     // rulează animația după ce noile noduri sunt în DOM
     this.animateProgress();

    setTimeout(() => {
      //this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    // return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    const doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
    // încearcă în ordine: selectorul cerut, apoi #CartDrawer, apoi containerul .cart-drawer, apoi wrapperul secțiunii
    const node =
      (selector && doc.querySelector(selector)) ||
      doc.getElementById('CartDrawer') ||
      doc.querySelector('.cart-drawer') ||
      doc.querySelector('.shopify-section') ||
      doc.body;
    return node.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
